import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getTenbeList } from '../../api/services/formService';

export const fetchUserTenBEs = createAsyncThunk(
  'userTenbe/fetchUserTenBEs',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await getTenbeList(userId);
      // API returns: { user: {...}, ten_bes: [...] }
      // Extract ten_bes array from response
      const responseData = response.data || response;
      return responseData?.ten_bes || responseData?.tenBEs || responseData || [];
    } catch (error) {
      console.error("Error fetching 10B list:", error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch 10B list"
      );
    }
  }
);

const userTenbeSlice = createSlice({
  name: 'userTenbe',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserTenBEs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserTenBEs.fulfilled, (state, action) => {
        state.loading = false;
        // Payload is already the ten_bes array (extracted in the thunk)
        state.data = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchUserTenBEs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default userTenbeSlice.reducer;

